import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import Helmet from "react-helmet";
import {
  MDBRow,
  MDBCol,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBContainer,
} from "mdbreact";

import LinkReadToo from "../../../../template/LinkReadToo";
import ShareBtns from "../../../../template/ShareBtns";
import Loader from "../../../../template/Loader";

import api from "../../../../../services/api";
import { formatDefaultDate } from "../../../../../utils/formatDate";

import "./styles.css";

export default ({ match }) => {
  const [data, setData] = useState({
    id: 0,
    author: "",
    category: "",
    content: "",
    date: "2020-06-15T03:00:00.000Z",
    description: "",
    image_name: "",
    image_url: "",
    slug: "",
    title: "",
  });
  const [researchesData, setResearchesData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function fetchData() {
      setLoading(true);

      try {
        const { data } = await api.get(`/posts/${match.params.slug}`);

        if (data.success) {
          setData(data.post);
        }
      } catch (error) {
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [match.params.slug]);

  useEffect(() => {
    (async function fetchData() {
      setLoading(true);

      try {
        const { data } = await api.get(`/posts?pagesize=10&category=2`);

        if (data.success) {
          setResearchesData(data.posts);
        }
      } catch (error) {
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="news-by-id">
      {loading ? (
        <Loader />
      ) : (
        <>
          <Helmet>
            <title>{data.title} - Ceprevi Itapetininga</title>
          </Helmet>

          <MDBContainer className="my-5">
            <MDBBreadcrumb>
              <MDBBreadcrumbItem>
                <Link to="/nossa-atuacao/pesquisas" className="link-breadcrumb">
                  Pesquisas
                </Link>
              </MDBBreadcrumbItem>
              <MDBBreadcrumbItem active>{data.title}</MDBBreadcrumbItem>
            </MDBBreadcrumb>

            <div className="date my-3 d-flex flex-wrap justify-content-between align-items-end">
              <ShareBtns
                title={data.title}
                description={data.description}
                image={data.image_url}
              />
              <p className="post-content">
                {formatDefaultDate(data.date)} - Publicado por {data.author}
              </p>
            </div>
          </MDBContainer>

          <div className="content container d-flex justify-content-center align-items-center flex-column">
            <h4 className="display-4 text-center">{data.title}</h4>
            <h3 className="text-muted my-3">{data.description}</h3>
            <img
              src={data.image_url}
              alt={data.image_name}
              className="img-new pb-5 pt-3"
            />
            <MDBRow>
              <MDBCol md="8" sm="12">
                {ReactHtmlParser(data.content)}
              </MDBCol>
              <MDBCol md="4" sm="12">
                <div style={{ position: "sticky", top: 100 }}>
                  <h1>LEIA TAMBÉM</h1>
                  {researchesData
                    .filter((research) => research.id !== data.id)
                    .map((item) => (
                      <LinkReadToo
                        path={`/nossa-atuacao/pesquisas/${item.slug}`}
                        title={item.title}
                      />
                    ))}
                </div>
              </MDBCol>
            </MDBRow>
          </div>
        </>
      )}
    </div>
  );
};
